import { createI18n } from 'vue-i18n'
import messages from '@/i18n/messages'
import { getInitialLocale } from '@/utils/utils'

export default createI18n({
  legacy: false, // 使用 Composition API
  locale: getInitialLocale(), // 使用新的获取语言方法
  fallbackLocale: 'en',
  messages,
})
